<template>
  <div class="verify-container">
    <div class="verify-box">
      <el-breadcrumb separator="/" style="margin-bottom: 20px">
        <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
        <el-breadcrumb-item>验证</el-breadcrumb-item>
      </el-breadcrumb>
      <h2>商家营业执照信息</h2>
      <hr />
      <p class="desc">根据国家工商总局《网络交易管理办法》要求对网店营业执照信息公示如下：</p>
      <el-form :model="form" ref="form" class="verify-form" @submit.native.prevent="onSubmit">
        <el-form-item label="验证码：" prop="captcha">
          <el-input v-model="form.captcha" placeholder="请输入图片中的验证码" style="width: 300px" />
          <canvas ref="captchaCanvas" class="captcha-img" @click="generateCaptcha"></canvas>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopVerify',
  data() {
    return {
      form: {
        captcha: ''
      },
      captchaText: ''
    }
  },
  mounted() {
    this.generateCaptcha()
  },
  methods: {
    // 生成随机验证码
    randomText(length = 4) {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
      let result = ''
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    },
    // 绘制验证码
    generateCaptcha() {
      this.captchaText = this.randomText()
      const canvas = this.$refs.captchaCanvas
      const ctx = canvas.getContext('2d')
      canvas.width = 100
      canvas.height = 40
      // 背景
      ctx.fillStyle = '#f8f8f8'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // 文本
      ctx.font = '24px Arial'
      ctx.fillStyle = '#333'
      ctx.textBaseline = 'middle'
      ctx.fillText(this.captchaText, 18, 22)
      // 干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = '#ccc'
        ctx.beginPath()
        ctx.moveTo(Math.random() * 100, Math.random() * 40)
        ctx.lineTo(Math.random() * 100, Math.random() * 40)
        ctx.stroke()
      }
    },
    // 校验
    onSubmit() {
      if (this.form.captcha.trim().toLowerCase() === this.captchaText.toLowerCase()) {
        this.$message.success('验证通过')
        // 跳转
        this.$router.push('/pc/mall/shopIntro')
      } else {
        this.$message.error('验证码错误，请重试')
        this.generateCaptcha()
        this.form.captcha = ''
      }
    }
  }
}
</script>

<style scoped>
.verify-container {
  background: #fafafa;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 60px;
}
.verify-box {
  background: #fff;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 2px 12px #0000000a;
  min-width: 600px;
}
.desc {
  color: #888;
  margin: 20px 0 30px 0;
}
.captcha-img {
  height: 40px;
  width: 100px;
  margin-left: 20px;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #eee;
}
</style>
